<div class="public-page card-page">
    <div class="public-container public-container_transparent">
        <div class="public-page-h1 public-page-h1_text-align_center card-page__h1">
            Не удалось завершить привязку карты
        </div>

        <div class="text-block text-block_text-align_center">
            <div class="text-block__simple-text">
                Перейдите на <a href="https://gosuslugi.ru/">gosuslugi.ru</a> и повторите попытку привязки карты еще раз
            </div>
        </div>
    </div>
</div>
